import type { AdminEnvironment } from './types-environment';

export const envAdmin: AdminEnvironment = Object.freeze(<AdminEnvironment>{
  basePath: 'https://uiapimf5c41c8714ee.azure-api.net/beta/web/ik/rpt/api',
  oauth: {
    clientId: '1704b1d3-542e-40c1-aedd-a49288a69038',
    scope: 'openid profile 1704b1d3-542e-40c1-aedd-a49288a69038',
    tokenEndpoint:
      'https://auth-dev.user.union-investment.de/b2cunioninvestmentdev.onmicrosoft.com/B2C_1A_SIGNIN_IKONLINE/oauth2/v2.0/authorize',
    issuer:
      'https://auth-dev.user.union-investment.de/b2cunioninvestmentdev.onmicrosoft.com/B2C_1A_SIGNIN_IKONLINE/v2.0/',
    redirectUri: window.location.origin + '/oauth2/callback',
  },
  logging: {
    connectionString:
      'InstrumentationKey=c239a6ab-bd01-466b-881a-d91745512ade;IngestionEndpoint=https://westeurope-4.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=f7ee889c-3719-4d8a-8c32-ad80801aa288',
  },
});
